import { useEffect, useState } from "react";
import MallDesign from "./MallDesign";
import { companyShopUseCase } from "../../../di/container";
import { useAuthStore } from "../../stores/auth-store";
import { CompanyAdminLayout } from "../../components/CompanyAdmin/CompanyAdminLayout";
import { LoadingSpinner } from "../../components/UI/LoadingSpinner";

export const MallDesignCheck = () => {
  const { user } = useAuthStore();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isShopCreated, setIsShopCreated] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      if (!user?.companyId) return;

      try {
        await companyShopUseCase.getShopHome(user.companyId);
        setIsShopCreated(true);
      } catch (e: unknown) {
        setIsShopCreated(false);
      }

      setIsLoading(false);
    })();
  }, []);
  return (
    <>
      {isShopCreated ? (
        <MallDesign />
      ) : (
        <>
          <CompanyAdminLayout>
            {isLoading ? (
              <div className="h-screen flex justify-center items-center"><LoadingSpinner /></div>
            ) : (
              <>
                <div className="mt-10 flex justify-center items-center">
                  <div className="text-start mx-4 max-w-[400px] flex flex-col items-center">
                    <img
                      src="/assets/icons/forbidden.svg"
                      alt="접근금지"
                      className="w-14"
                    />
                    <div>
                      <h2 className="mt-8 mb-3 text-[1.5rem] font-bold">
                        쇼핑몰이 존재하지 않습니다.
                      </h2>
                      <div>
                        쇼핑몰이 개설되지 않은 회사는 쇼핑몰을 디자인할 수
                        없습니다. 내 회사 정보에 정보를 입력하여 쇼핑몰을
                        개설해보세요.
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </CompanyAdminLayout>
        </>
      )}
    </>
  );
};
